import { createAction, props } from '@ngrx/store';
import { Company } from '../../shared/interfaces/company.interface';

export const getCompany = createAction('[auth] GET_COMPANY', props<{ subdomain: string }>());
export const getCompanySuccess = createAction('[auth] GET_COMPANY_SUCCESS', props<{ company: Company }>());
export const getCompanyFail = createAction('[auth] GET_COMPANY_FAIL', props<{ error: Error }>());
